export default function Clear() {
  return <span>ⓧ</span>;
}
